import React, { useEffect, useState } from "react";
import Home from "../component/Home";
import { getUserAllService } from "../services/UsermanagementService";
import { Apinames } from "../utils/Apiname";
import { getDashboardSummary } from "../services/AiService";
import { DashboardSummary } from "../types/ai";
import { currentRole } from "../utils/permissions";

type Props = {};

const HomeScreen = (props: Props) => {
  const [mainLoading, setMainLoading] = useState<boolean>(true);
  const [allUserStats, setAllUserStats] = useState<any[]>([]);
  const [summary, setSummary] = useState<DashboardSummary | null>(null);
  const isPlatform = currentRole() === "SUPER_ADMIN";

  useEffect(() => {
    getuserStats();
    // Platform operators have no tenant data.
    if (!isPlatform) getDashboardSummary().then(setSummary).catch(() => setSummary(null));
  }, [isPlatform]);

  const getuserStats = async () => {
    try {
      const response = await getUserAllService(Apinames.usersStats);
      if (response?.result) {
        // let data :any= {
        //   total: 9,
        //   active: 20,
        //   checklistSubmittedThisMonth: 10,
        //   checklistPendingThisMonth: 20,
        // };
        setAllUserStats(response?.result);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setMainLoading(false);
    }
  };
  return <Home mainLoading={mainLoading} allUserStats={allUserStats} summary={summary} isPlatform={isPlatform} />;
};

export default HomeScreen;
